/**
 * Restores the Guide Me floating launcher after the user dismissed it from
 * the teaser bubble. Only renders when {@link useGuideMeHeaderRecallVisible}
 * is true (must be under `GuideMeProvider`, e.g. via `GuideMeShell` in the host).
 */

import {
  useGuideMeFloatingLauncher,
  useGuideMeHeaderRecallVisible,
} from '@empowernow/guide-me-react';

export function GuideMeHeaderRecallButton() {
  const showRecall = useGuideMeHeaderRecallVisible();
  const { restoreFloatingLauncher } = useGuideMeFloatingLauncher();

  if (!showRecall) return null;

  return (
    <button
      type="button"
      data-testid="guide-me-header-recall"
      aria-label="Show Guide Me launcher"
      title="Show Guide Me"
      onClick={() => restoreFloatingLauncher()}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        borderRadius: '50%',
        border: '1px solid rgba(255,255,255,0.18)',
        background: 'rgba(255,255,255,0.06)',
        color: 'var(--header-text, rgba(255,255,255,0.9))',
        fontSize: 16,
        fontWeight: 600,
        cursor: 'pointer',
        lineHeight: 1,
        flexShrink: 0,
        transition: 'background 0.15s ease, border-color 0.15s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.28)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.18)';
      }}
    >
      ?
    </button>
  );
}
